module.exports = __webpack_public_path__ + "fonts/Inter-roman.var.ba4caef.woff2";